import { tok_login } from '@/utils/HttpUtil';
import { message } from 'antd';
import { stringify } from 'querystring';
import { Effect, Reducer, Subscription, history } from 'umi';

export interface UserModelState {
  id: number | string;
  name: string;
  tokUser: any;
  isLogin: boolean;
}

export interface DispatchProps {
  login?: () => void;
  logout?: () => void;
}

export interface UserModelType {
  namespace: string;
  state: UserModelState;
  effects: {
    login: Effect;
    logout: Effect;
  };
  reducers: {
    // 启用 immer
    save: Reducer<UserModelState>;
  };
  subscriptions: { setup: Subscription };
}

const waitTime = (time: number = 100) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

/**
 * 此方法会跳转到 redirect 参数所在的位置
 */
const goto = () => {
  const { query } = history.location;
  const { redirect } = query as { redirect: string };
  // redirect ||
  window.location.href = '/';
};

export default {
  namespace: 'userInfo',
  state: {
    isLogin: false,
    userInfo: {},
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: {
    *login({ payload }, { call, put }) {
      console.log(payload);
      const res = yield call(tok_login, payload);
      console.log(res);
      const data = {
        userInfo: {},
        isLogin: false,
      };
      if (res.loginResult === 0) {
        localStorage.setItem(
          process.env.REACT_APP_CONFIG_ENV + '_boss_ticket',
          JSON.stringify({
            appId: res.webTicket.appId,
            c2: res.webTicket.c2,
            c3: res.webTicket.c3,
            c3Key: res.webTicket.c3Key,
            c3Iv: res.webTicket.c3Iv,
            expireTs: res.webTicket.expireTs,
          }),
        );
        localStorage.setItem(
          process.env.REACT_APP_CONFIG_ENV + '_boss_user_2',
          JSON.stringify({
            name: res.account,
            avatar:
              'https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png',
            // userid: "00000001",
            access: res.role,
            headImgUrl: res.tokUser.headImgUrl,
            uid: res.tokUser.uid,
            nick: res.tokUser.userNick,
            phone: res.tokUser.userMobile,
          }),
        );
        console.log(res.tokUser, '=========data.tokUser');
        data.userInfo = res.tokUser;
        window.location.href = '/home';
        waitTime(3000);
        message.success('登录成功！');
        goto();
      } else {
        message.error('账号或密码错误，请重试！');
      }
      yield put({ type: 'save', payload: data });
    },
    *logout(_, { call, put }) {
      localStorage.removeItem(
        process.env.REACT_APP_CONFIG_ENV + '_boss_user_2',
      );
      localStorage.removeItem('status');
      const { query, pathname } = history.location;
      const { redirect } = query;
      // Note: There may be security issues, please note
      if (window.location.pathname !== '/user/login' && !redirect) {
        history.replace({
          pathname: '/user/login',
          search: stringify({
            redirect: pathname,
          }),
        });
      }
      const payload = {
        userInfo: {},
        isLogin: false,
      };
      yield put({ type: 'save', payload });
    },
  },
  subscriptions: {
    setup({ dispatch, history }) {
      const user = JSON.parse(
        localStorage.getItem(process.env.REACT_APP_CONFIG_ENV + '_boss_user_2'),
      );
      const payload = {
        userInfo: {},
        isLogin: false,
      };
      if (user) {
        payload.userInfo = user;
        payload.isLogin = true;
      } else {
        payload.userInfo = {};
        payload.isLogin = false;
      }
      dispatch({ type: 'save', payload });
    },
  },
};
